import React, { useEffect, useState, Component } from 'react';
import { ChevronDown, Menu, X, MapPin, Calendar, Star, Shield, Clock, Smartphone, MessageCircle, CheckCircle2, ArrowRight, Instagram, Mail, Phone, Sparkles, Scissors, Droplet, Heart, HelpCircle, Quote, ChevronUp, ChevronLeft, ChevronRight, Award } from 'lucide-react';
// --- Assets ---
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/nGSrBzMNKGdRJukjbk99rH/logo_belen1.png';
const HERO_BANNER = 'https://cdn.magicpatterns.com/uploads/vTVBZeLsACT3FmhbtL3giq/banner_k.png';
const OWNER_IMG_BIO = 'https://cdn.magicpatterns.com/uploads/aWheiNXurp8HvpU9s3271o/WhatsApp_Image_2026-05-04_at_6.07.46_PM_(1).jpg';
const LOREAL_IMG = 'https://cdn.magicpatterns.com/uploads/sWADQbmDPW8LwFaKr1kNYR/loreal.jpg';
const WHATSAPP_LINK = 'https://wa.me/54938765186044?text=Hola!%20Vengo%20de%20la%20página%20web%20y%20quiero%20reservar%20un%20turno.';
const CAROUSEL_MEDIA = [{
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/r8ukfNAKEvw3kViScX1toT/colortrend_2025✨_lorealprofessional.jpg'
}, {
  type: 'video',
  url: 'https://cdn.magicpatterns.com/uploads/41SX73p5CREyBVnRwKKZYs/BALAYAGE-CONTOURING Aquí trabajamos estás 2 técnicas 🫶🏼♥️Déjanos tu ♥️ si te gusto este cambio.mp4'
}, {
  type: 'video',
  url: 'https://cdn.magicpatterns.com/uploads/2X89yX1Qf6JTyEa1LTrDbt/ESTÁS BUSCANDO UN CAMBIO DE LOOK DEJA TODOS EN NUESTRAS MANOS 🫶🏼❤️@belen.carrillo.estudio Rese (5).mp4'
}];
// --- Components ---
const Button = ({
  children,
  className = '',
  variant = 'primary',
  href,
  ...props
}: any) => {
  const baseStyle = 'inline-flex items-center justify-center px-8 py-4 font-bold transition-all duration-300 ease-in-out text-center rounded-full';
  const variants = {
    primary: 'bg-[#C5A059] text-white hover:bg-[#b08d4a] shadow-lg hover:shadow-xl hover:-translate-y-1',
    secondary: 'bg-rose-100 text-rose-900 hover:bg-rose-200 shadow-md',
    outline: 'border-2 border-[#C5A059] text-[#C5A059] hover:bg-[#C5A059] hover:text-white',
    dark: 'bg-zinc-900 text-white hover:bg-zinc-800',
    whatsapp: 'bg-[#25D366] hover:bg-[#1ebd5c] text-white shadow-[#25D366]/30 hover:-translate-y-1'
  };
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseStyle} ${variants[variant as keyof typeof variants]} ${className}`} {...props} data-id="element-0">
        {children}
      </a>;
  }
  return <button className={`${baseStyle} ${variants[variant as keyof typeof variants]} ${className}`} {...props} data-id="element-1">
      {children}
    </button>;
};
const Section = ({
  children,
  className = '',
  id = ''
}: any) => <section id={id} className={`py-20 px-6 md:px-12 lg:px-24 ${className}`} data-id="element-2">
    <div className="max-w-6xl mx-auto" data-id="element-3">{children}</div>
  </section>;
const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: any) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200" data-id="element-5">
        <div className="flex justify-between items-center p-6 border-b border-zinc-100" data-id="element-6">
          <h3 className="text-2xl font-bold text-zinc-900 font-serif" data-id="element-7">
            {title}
          </h3>
          <button onClick={onClose} className="p-2 text-zinc-400 hover:text-zinc-900 transition-colors rounded-full hover:bg-zinc-100" data-id="element-8">
            <X size={24} data-id="element-9" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-zinc-600 space-y-4" data-id="element-10">
          {children}
        </div>
      </div>
    </div>;
};
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-zinc-200 rounded-xl overflow-hidden mb-4 bg-white transition-all duration-300 hover:border-[#C5A059]/50 shadow-sm" data-id="element-11">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-12">
        <span className="font-bold text-zinc-900 pr-4" data-id="element-13">{question}</span>
        {isOpen ? <ChevronUp className="text-[#C5A059] shrink-0" size={20} data-id="element-14" /> : <ChevronDown className="text-zinc-400 shrink-0" size={20} data-id="element-15" />}
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-16">
        <p className="text-zinc-600" data-id="element-17">{answer}</p>
      </div>
    </div>;
};
const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(i => (i + 1) % CAROUSEL_MEDIA.length);
  const prev = () => setCurrentIndex(i => (i - 1 + CAROUSEL_MEDIA.length) % CAROUSEL_MEDIA.length);
  // Auto-play
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, []);
  return <div className="relative w-full max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-[3/4] bg-zinc-900 group" data-id="element-18">
      {/* Sliding Container */}
      <div className="flex h-full w-full transition-transform duration-700 ease-in-out" style={{
      transform: `translateX(-${currentIndex * 100}%)`
    }} data-id="element-19">
        {CAROUSEL_MEDIA.map((media, i) => <div key={i} className="w-full h-full shrink-0 relative" data-id="element-20">
            {media.type === 'video' ? <video src={media.url} autoPlay muted loop playsInline className="w-full h-full object-cover" data-id="element-21" /> : <img src={media.url} alt="Trabajo de estudio" className="w-full h-full object-cover" data-id="element-22" />}
          </div>)}
      </div>

      {/* Controls */}
      <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 z-20 p-3 bg-white/80 hover:bg-white rounded-full shadow-lg text-zinc-900 transition-all opacity-0 group-hover:opacity-100 -translate-x-4 group-hover:translate-x-0" data-id="element-23">
        <ChevronLeft size={24} data-id="element-24" />
      </button>
      <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 z-20 p-3 bg-white/80 hover:bg-white rounded-full shadow-lg text-zinc-900 transition-all opacity-0 group-hover:opacity-100 translate-x-4 group-hover:translate-x-0" data-id="element-25">
        <ChevronRight size={24} data-id="element-26" />
      </button>

      {/* Indicators */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2 bg-black/20 px-4 py-2 rounded-full backdrop-blur-sm" data-id="element-27">
        {CAROUSEL_MEDIA.map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-all ${i === currentIndex ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/80'}`} data-id="element-28" />)}
      </div>
    </div>;
};
// --- Main App ---
export function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
  };
  return <div className="font-sans text-zinc-800 bg-[#FAFAFA] selection:bg-[#C5A059] selection:text-white" data-id="element-29">
      <style data-id="element-30">{`
        .bg-checkerboard {
          background-color: #ffffff;
          background-image: 
            linear-gradient(45deg, #e5e5e5 25%, transparent 25%), 
            linear-gradient(-45deg, #e5e5e5 25%, transparent 25%), 
            linear-gradient(45deg, transparent 75%, #e5e5e5 75%), 
            linear-gradient(-45deg, transparent 75%, #e5e5e5 75%);
          background-size: 20px 20px;
          background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
        }
      `}</style>

      {/* 01. NAVBAR */}
      <nav className={`fixed top-0 w-full z-40 transition-all duration-300 ${isScrolled ? 'bg-[#fbfbfb] py-2' : 'bg-[#fbfbfb] py-4'}`} data-id="element-31">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-32">
          {/* LOGO SIZE INCREASED SIGNIFICANTLY */}
          <img src={LOGO_URL} alt="Belén Carrillo Estudio" className="h-28 md:h-36 object-contain cursor-pointer transition-all duration-300 mix-blend-multiply" onClick={() => window.scrollTo(0, 0)} data-id="element-33" />

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-34">
            <div className="relative group" data-id="element-35">
              <button className="flex items-center gap-1 font-medium text-zinc-700 hover:text-[#C5A059] transition-colors" onClick={() => setIsServicesOpen(!isServicesOpen)} onMouseEnter={() => setIsServicesOpen(true)} data-id="element-36">
                Servicios{' '}
                <ChevronDown size={16} className={`transition-transform ${isServicesOpen ? 'rotate-180' : ''}`} data-id="element-37" />
              </button>

              {/* Dropdown Services */}
              <div className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-80 bg-white shadow-xl border border-zinc-100 rounded-xl overflow-hidden transition-all duration-200 origin-top ${isServicesOpen ? 'scale-y-100 opacity-100' : 'scale-y-0 opacity-0'}`} onMouseLeave={() => setIsServicesOpen(false)} data-id="element-38">
                <div className="p-2 max-h-[70vh] overflow-y-auto" data-id="element-39">
                  <div className="mb-2" data-id="element-40">
                    <button onClick={() => scrollToSection('colorimetria')} className="w-full text-left px-4 py-2 hover:bg-rose-50 rounded-lg text-sm font-bold text-zinc-900 flex items-center gap-3 transition-colors" data-id="element-41">
                      <Sparkles size={16} className="text-[#C5A059]" data-id="element-42" />{' '}
                      Colorimetría & Cambios
                    </button>
                    <div className="pl-11 pr-4 py-1 flex flex-col gap-1" data-id="element-43">
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('colorimetria')} data-id="element-44">
                        INOA Sin Amoníaco
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('colorimetria')} data-id="element-45">
                        Majirel L'Oréal
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('colorimetria')} data-id="element-46">
                        Balayage & Mechas
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('colorimetria')} data-id="element-47">
                        Corrección de color
                      </span>
                    </div>
                  </div>

                  <div className="mb-2 border-t border-zinc-100 pt-2" data-id="element-48">
                    <button onClick={() => scrollToSection('tratamientos')} className="w-full text-left px-4 py-2 hover:bg-rose-50 rounded-lg text-sm font-bold text-zinc-900 flex items-center gap-3 transition-colors" data-id="element-49">
                      <Droplet size={16} className="text-[#C5A059]" data-id="element-50" /> Cabello
                      Sano & Tratamientos
                    </button>
                    <div className="pl-11 pr-4 py-1 flex flex-col gap-1" data-id="element-51">
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('tratamientos')} data-id="element-52">
                        Cauterización / S.O.S.
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('tratamientos')} data-id="element-53">
                        Power Mix & Metal Detox
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('tratamientos')} data-id="element-54">
                        Absolut Repair Molecular
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('tratamientos')} data-id="element-55">
                        Células Madres & Karseell
                      </span>
                    </div>
                  </div>

                  <div className="border-t border-zinc-100 pt-2" data-id="element-56">
                    <button onClick={() => scrollToSection('estetica')} className="w-full text-left px-4 py-2 hover:bg-rose-50 rounded-lg text-sm font-bold text-zinc-900 flex items-center gap-3 transition-colors" data-id="element-57">
                      <Heart size={16} className="text-[#C5A059]" data-id="element-58" /> Estética
                      Integral
                    </button>
                    <div className="pl-11 pr-4 py-1 flex flex-col gap-1" data-id="element-59">
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('estetica')} data-id="element-60">
                        Tratamientos Faciales
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('estetica')} data-id="element-61">
                        Tratamientos Corporales
                      </span>
                      <span className="text-xs text-zinc-500 hover:text-[#C5A059] cursor-pointer" onClick={() => scrollToSection('estetica')} data-id="element-62">
                        Depilación Definitiva & Uñas
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button onClick={() => scrollToSection('galeria')} className="font-medium text-zinc-700 hover:text-[#C5A059] transition-colors" data-id="element-63">
              Galería
            </button>
            <button onClick={() => scrollToSection('testimonios')} className="font-medium text-zinc-700 hover:text-[#C5A059] transition-colors" data-id="element-64">
              Testimonios
            </button>

            <Button href={WHATSAPP_LINK} className="px-6 py-2.5 text-sm" data-id="element-65">
              Reservar Turno
            </Button>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden p-2 text-zinc-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-66">
            {isMobileMenuOpen ? <X size={24} data-id="element-67" /> : <Menu size={24} data-id="element-68" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-2xl border-t flex flex-col p-4 animate-in slide-in-from-top-2 max-h-[80vh] overflow-y-auto" data-id="element-69">
            <div className="font-bold text-zinc-400 text-xs uppercase tracking-wider mb-2 px-4 mt-2" data-id="element-70">
              Servicios
            </div>

            <div className="mb-2" data-id="element-71">
              <button onClick={() => scrollToSection('colorimetria')} className="w-full text-left px-4 py-2 hover:bg-rose-50 text-zinc-900 font-bold flex items-center gap-3" data-id="element-72">
                <Sparkles size={18} className="text-[#C5A059]" data-id="element-73" /> Colorimetría
              </button>
              <div className="pl-12 pr-4 py-1 flex flex-col gap-2" data-id="element-74">
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('colorimetria')} data-id="element-75">
                  INOA Sin Amoníaco
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('colorimetria')} data-id="element-76">
                  Majirel L'Oréal
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('colorimetria')} data-id="element-77">
                  Balayage & Mechas
                </span>
              </div>
            </div>

            <div className="mb-2" data-id="element-78">
              <button onClick={() => scrollToSection('tratamientos')} className="w-full text-left px-4 py-2 hover:bg-rose-50 text-zinc-900 font-bold flex items-center gap-3" data-id="element-79">
                <Droplet size={18} className="text-[#C5A059]" data-id="element-80" /> Tratamientos
              </button>
              <div className="pl-12 pr-4 py-1 flex flex-col gap-2" data-id="element-81">
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('tratamientos')} data-id="element-82">
                  Cauterización / S.O.S.
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('tratamientos')} data-id="element-83">
                  Power Mix & Metal Detox
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('tratamientos')} data-id="element-84">
                  Absolut Repair Molecular
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('tratamientos')} data-id="element-85">
                  Células Madres
                </span>
              </div>
            </div>

            <div className="mb-2" data-id="element-86">
              <button onClick={() => scrollToSection('estetica')} className="w-full text-left px-4 py-2 hover:bg-rose-50 text-zinc-900 font-bold flex items-center gap-3" data-id="element-87">
                <Heart size={18} className="text-[#C5A059]" data-id="element-88" /> Estética Integral
              </button>
              <div className="pl-12 pr-4 py-1 flex flex-col gap-2" data-id="element-89">
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('estetica')} data-id="element-90">
                  Tratamientos Faciales
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('estetica')} data-id="element-91">
                  Tratamientos Corporales
                </span>
                <span className="text-sm text-zinc-500" onClick={() => scrollToSection('estetica')} data-id="element-92">
                  Depilación Definitiva & Uñas
                </span>
              </div>
            </div>

            <div className="h-px bg-zinc-100 my-2 mx-4" data-id="element-93"></div>
            <button onClick={() => scrollToSection('galeria')} className="text-left px-4 py-3 text-zinc-700 font-medium" data-id="element-94">
              Galería
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-left px-4 py-3 text-zinc-700 font-medium" data-id="element-95">
              Preguntas Frecuentes
            </button>

            <Button href={WHATSAPP_LINK} className="mt-4 w-full" data-id="element-96">
              Reservar Turno
            </Button>
          </div>}
      </nav>

      {/* 01. HERO SECTION (Single Banner Animated) */}
      <section className="pt-44 md:pt-48 bg-[#0a0a0a] overflow-hidden" data-id="element-97">
        <style data-id="element-98">{`
          @keyframes slowZoom {
            0% { transform: scale(1); }
            50% { transform: scale(1.04); }
            100% { transform: scale(1); }
          }
          .animate-slow-zoom {
            animation: slowZoom 15s ease-in-out infinite;
          }
        `}</style>
        <div className="w-full relative flex justify-center animate-in fade-in duration-1000" data-id="element-99">
          <img src={HERO_BANNER} alt="Belén Carrillo Estudio" className="w-full h-auto max-w-[1920px] object-contain animate-slow-zoom" data-id="element-100" />
        </div>
      </section>

      {/* L'OREAL TRUST BADGE */}
      <div className="bg-white border-b border-zinc-100 shadow-sm relative z-10 -mt-2" data-id="element-101">
        <div className="max-w-4xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12" data-id="element-102">
          <div className="flex items-center gap-3 text-zinc-800" data-id="element-103">
            <Award className="text-[#C5A059]" size={32} data-id="element-104" />
            <span className="text-2xl font-serif font-bold uppercase tracking-widest" data-id="element-105">
              Colorista Experta
            </span>
          </div>
          <div className="hidden md:block w-px h-12 bg-zinc-200" data-id="element-106"></div>
          <img src={LOREAL_IMG} alt="L'Oréal Professionnel Paris" className="h-16 md:h-20 object-contain mix-blend-multiply" data-id="element-107" />
        </div>
      </div>

      {/* 02. INTRO TEXT SECTION */}
      <Section className="bg-white pt-16 pb-12" data-id="element-108">
        <div className="max-w-4xl mx-auto text-center" data-id="element-109">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-zinc-900 leading-[1.1] mb-8" data-id="element-110">
            Tu cabello merece más que un simple corte.{' '}
            <br className="hidden md:block" data-id="element-111" />
            <span className="text-[#C5A059] italic" data-id="element-112">
              Merece una transformación.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-zinc-600 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-113">
            En Belén Carrillo Estudio no solo hacemos corte, color, balayage…Te
            devolvemos la confianza que sentís cuando te mirás al espejo y
            decís:{' '}
            <strong className="text-zinc-900 font-serif italic text-2xl" data-id="element-114">
              "Así soy yo."
            </strong>
          </p>

          <div className="grid grid-cols-3 gap-4 mb-10 max-w-2xl mx-auto" data-id="element-115">
            <div className="flex flex-col items-center Text-center p-4 rounded-2xl bg-zinc-50 border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-116">
              <Clock className="text-[#C5A059] mb-3" size={28} data-id="element-117" />
              <span className="text-xs md:text-sm font-bold text-zinc-800 uppercase" data-id="element-118">
                Turno Rápido
              </span>
            </div>
            <div className="flex flex-col items-center text-center p-4 rounded-2xl bg-zinc-50 border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-119">
              <MapPin className="text-[#C5A059] mb-3" size={28} data-id="element-120" />
              <span className="text-xs md:text-sm font-bold text-zinc-800 uppercase" data-id="element-121">
                Cerrillos, Salta
              </span>
            </div>
            <div className="flex flex-col items-center text-center p-4 rounded-2xl bg-zinc-50 border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-122">
              <MessageCircle className="text-[#C5A059] mb-3" size={28} data-id="element-123" />
              <span className="text-xs md:text-sm font-bold text-zinc-800 uppercase" data-id="element-124">
                Consulta Gratis
              </span>
            </div>
          </div>

          <Button href={WHATSAPP_LINK} className="w-full sm:w-auto group mt-4" data-id="element-125">
            QUIERO RESERVAR MI TURNO AHORA
            <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-126" />
          </Button>
        </div>
      </Section>

      {/* 03. GALERÍA (Carousel) */}
      <Section className="bg-zinc-50 border-y border-zinc-100" id="galeria" data-id="element-127">
        <div className="text-center mb-12" data-id="element-128">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-zinc-900 mb-4" data-id="element-129">
            Galería de Transformaciones
          </h2>
          <p className="text-xl text-zinc-600" data-id="element-130">
            Resultados reales que hablan por sí solos.
          </p>
        </div>

        <Carousel data-id="element-131" />
      </Section>

      {/* 04. EL PROBLEMA */}
      <Section className="bg-zinc-900 text-white relative overflow-hidden" data-id="element-132">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#C5A059] rounded-full blur-[150px] opacity-20" data-id="element-133"></div>

        <div className="max-w-4xl mx-auto relative z-10" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-12" data-id="element-135">
            ¿Te identificás con alguna de estas situaciones?
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-136">
            {['Salí de la peluquería y el color no era para nada lo que pedí...', 'Llevo meses queriendo hacerme un cambio de look pero no confío en nadie...', 'Mi cabello está seco, opaco y sin vida y no sé qué hacer...', 'Quiero depilarme definitivamente pero me da miedo que no funcione...'].map((text, i) => <div key={i} className="bg-zinc-800/50 p-6 rounded-2xl border border-zinc-700/50 flex gap-4 items-start" data-id="element-137">
                <Quote className="text-[#C5A059] shrink-0 rotate-180" size={24} data-id="element-138" />
                <p className="text-lg text-zinc-300 italic" data-id="element-139">{text}</p>
              </div>)}
          </div>

          <div className="text-center bg-white/5 p-8 rounded-3xl border border-white/10 backdrop-blur-sm" data-id="element-140">
            <p className="text-xl md:text-2xl font-medium mb-4" data-id="element-141">
              Si dijiste que sí a alguna de estas...{' '}
              <span className="text-[#C5A059]" data-id="element-142">no es tu culpa.</span>
            </p>
            <p className="text-lg text-zinc-400" data-id="element-143">
              El problema no es tu cabello. El problema es que nunca encontraste
              a alguien que realmente escuche lo que querés y tenga la técnica
              para lograrlo.{' '}
              <strong className="text-white" data-id="element-144">Eso cambia hoy.</strong>
            </p>
          </div>
        </div>
      </Section>

      {/* 05. LA SOLUCIÓN (Bio) */}
      <Section className="bg-white" data-id="element-145">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-146">
          <div className="w-full md:w-2/5 relative" data-id="element-147">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-xl" data-id="element-148">
              <img src={OWNER_IMG_BIO} alt="Belén Carrillo" className="w-full h-full object-cover object-top" data-id="element-149" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-xl border border-zinc-100" data-id="element-150">
              <div className="flex items-center gap-3" data-id="element-151">
                <div className="w-12 h-12 bg-rose-50 rounded-full flex items-center justify-center" data-id="element-152">
                  <Star className="text-[#C5A059]" size={24} data-id="element-153" />
                </div>
                <div data-id="element-154">
                  <p className="font-bold text-zinc-900" data-id="element-155">Belén Carrillo</p>
                  <p className="text-sm text-zinc-500" data-id="element-156">
                    Estilista/ colorista profesional
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full md:w-3/5" data-id="element-157">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-zinc-900 mb-6 flex items-center gap-3" data-id="element-158">
              Hola, soy Belén Carrillo{' '}
              <Sparkles className="text-[#C5A059]" size={32} data-id="element-159" />
            </h2>
            <div className="space-y-6 text-lg text-zinc-600 leading-relaxed" data-id="element-160">
              <p className="font-medium text-zinc-800 text-xl" data-id="element-161">
                Colorista experta y estilista especializada en transformar
                cabellos — y la autoestima de quienes los llevan.
              </p>
              <p data-id="element-162">
                Hace 17 años que hago lo que amo, y hace 11 años que Belc
                Estudio existe, en el cual trabajo con un solo objetivo: que
                cuando salgas de mi estudio, sientas que la mejor versión de vos
                acaba de aparecer.
              </p>
              <p data-id="element-163">
                No tengo clientes, tengo personas con historias, estilos y
                sueños distintos. Con ganas de verse cada día mejor. Y para eso
                nos capacitamos continuamente, y poder darte un servicio de
                excelencia. Con lo último en tendencia y técnicas actualizadas.
              </p>
              <p data-id="element-164">
                Siempre trabajamos con productos de calidad (Loreal
                Professionnel) para mejores resultados sin dañar tu cabello.
              </p>
              <p data-id="element-165">
                Si necesitas un corte, color, balayage, tratamientos para
                recuperar tu cabello dañado, realizamos un diagnóstico sin
                cargo. Todo para una melena perfecta 🤍
              </p>
              <div className="bg-rose-50 p-6 rounded-2xl border-l-4 border-[#C5A059]" data-id="element-166">
                <p className="font-bold text-zinc-900 mb-2" data-id="element-167">
                  Ademas podes disfrutar de otros servicios con la misma calidad
                  de atención:
                </p>
                <ul className="list-disc pl-5 space-y-1 text-zinc-800" data-id="element-168">
                  <li data-id="element-169">Tratamientos faciales</li>
                  <li data-id="element-170">Tratamientos corporales</li>
                  <li data-id="element-171">Depilación definitiva láser</li>
                </ul>
              </div>
              <p className="font-serif italic text-2xl text-zinc-800 pt-4" data-id="element-172">
                Eso es BelC Estudio. Un espacio donde el cabello sano, brillante
                y natural no es el objetivo final — es el punto de partida.
              </p>
              <p className="font-medium text-zinc-800" data-id="element-173">
                Donde no solo cuidamos tu pelo, piel y cuerpo, sino también tu
                imagen, tu autoestima y amor propio. Cuidarse hace bien 🤍
              </p>
            </div>
          </div>
        </div>
      </Section>

      {/* 06. SERVICIOS */}
      <Section className="bg-[#FAFAFA]" id="servicios" data-id="element-174">
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-zinc-900 mb-4" data-id="element-176">
            ¿Qué podés lograr en BelC Estudio?
          </h2>
          <div className="w-24 h-1 bg-[#C5A059] mx-auto rounded-full" data-id="element-177"></div>
        </div>

        <div className="space-y-16 max-w-5xl mx-auto" data-id="element-178">
          {/* Categoria 1 */}
          <div id="colorimetria" className="scroll-mt-32" data-id="element-179">
            <div className="flex items-center gap-4 mb-8 border-b border-zinc-200 pb-4" data-id="element-180">
              <div className="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center border border-zinc-100" data-id="element-181">
                <Sparkles className="text-[#C5A059]" size={24} data-id="element-182" />
              </div>
              <h3 className="text-2xl font-bold text-zinc-900" data-id="element-183">
                Colorimetría & Cambios de look
              </h3>
            </div>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-184">
              {[{
              s: 'Coloración INOA SIN AMONÍACO',
              r: 'Coloración permanente sin olor, máximo confort para el cuero cabelludo'
            }, {
              s: 'Coloración MAJIREL - LOREAL',
              r: 'Color rico, profundo e intenso con cobertura perfecta'
            }, {
              s: 'Coloración completa',
              r: 'Un color que dure, brille y se vea natural'
            }, {
              s: 'Balayage / Mechas',
              r: 'Luces perfectas adaptadas a tu tono de piel'
            }, {
              s: 'Corrección de color',
              r: 'Eliminamos tonos no deseados, y corregimos trabajos mál realizados.'
            }, {
              s: 'Corte personalizado',
              r: 'Un corte ideal para tu rostro y tipo de cabello, con asesoramiento previo.'
            }, {
              s: 'Tonalización',
              r: 'Refrescá tu color entre sesiones'
            }, {
              s: 'Cambio de look total',
              r: 'Nueva imagen, nueva energía, nueva vos'
            }].map((item, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-185">
                  <h4 className="font-bold text-zinc-900 mb-2 flex items-center gap-2" data-id="element-186">
                    <CheckCircle2 size={18} className="text-[#C5A059]" data-id="element-187" />{' '}
                    {item.s}
                  </h4>
                  <p className="text-zinc-600 pl-6" data-id="element-188">{item.r}</p>
                </div>)}
            </div>
          </div>

          {/* Categoria 2 */}
          <div id="tratamientos" className="scroll-mt-32" data-id="element-189">
            <div className="flex items-center gap-4 mb-8 border-b border-zinc-200 pb-4" data-id="element-190">
              <div className="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center border border-zinc-100" data-id="element-191">
                <Scissors className="text-[#C5A059]" size={24} data-id="element-192" />
              </div>
              <h3 className="text-2xl font-bold text-zinc-900" data-id="element-193">
                Cabello Sano & Tratamientos
              </h3>
            </div>
            <p className="text-lg text-zinc-600 mb-6" data-id="element-194">
              Tratamientos para un cabello sano, con brillo y movimiento
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-195">
              {[{
              s: 'Tratamiento estrella: Cauterización o S.O.S.',
              r: 'Recuperación intensiva para cabellos extremadamente dañados'
            }, {
              s: 'POWER MIX',
              r: 'Tratamiento personalizado mezclado en el momento'
            }, {
              s: 'METAL DETOX',
              r: 'Neutraliza los metales dentro de la fibra capilar'
            }, {
              s: "Máscara de L'Oréal",
              r: 'Nutrición profunda con productos de primera línea'
            }, {
              s: 'Tratamiento Karseell',
              r: 'Maca essence para reparación de colágeno'
            }, {
              s: 'Tratamiento Absolut Repair Molecular',
              r: 'Reconstruye la estructura molecular del cabello'
            }, {
              s: 'Tratamiento de Células Madres',
              r: 'Regeneración capilar desde el interior'
            }, {
              s: 'Hidratación profunda',
              r: 'Según tu tipo de cabello y el grado de daño que tenga. Con diagnostico previo.'
            }, {
              s: 'Keratina / Alisado',
              r: 'Cabello dócil, sin frizz, sin maltrato'
            }, {
              s: 'Reconstrucción capilar',
              r: 'Devolvemos vida al cabello dañado'
            }].map((item, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-196">
                  <h4 className="font-bold text-zinc-900 mb-2 flex items-center gap-2" data-id="element-197">
                    <CheckCircle2 size={18} className="text-[#C5A059]" data-id="element-198" />{' '}
                    {item.s}
                  </h4>
                  <p className="text-zinc-600 pl-6" data-id="element-199">{item.r}</p>
                </div>)}
            </div>
          </div>

          {/* Categoria 3 */}
          <div id="estetica" className="scroll-mt-32" data-id="element-200">
            <div className="flex items-center gap-4 mb-8 border-b border-zinc-200 pb-4" data-id="element-201">
              <div className="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center border border-zinc-100" data-id="element-202">
                <Heart className="text-[#C5A059]" size={24} data-id="element-203" />
              </div>
              <h3 className="text-2xl font-bold text-zinc-900" data-id="element-204">
                Estética Integral
              </h3>
            </div>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-205">
              {/* Faciales */}
              <div className="bg-white p-8 rounded-3xl shadow-sm border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-206">
                <h4 className="text-xl font-bold text-zinc-900 mb-6 flex items-center gap-2 border-b border-zinc-100 pb-4" data-id="element-207">
                  <Sparkles size={20} className="text-[#C5A059]" data-id="element-208" /> Tratamientos
                  Faciales
                </h4>
                <ul className="space-y-4" data-id="element-209">
                  <li className="flex items-start gap-3" data-id="element-210">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-211" />
                    <span className="text-zinc-700" data-id="element-212">
                      Limpieza facial profunda con o sin aparatos.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-213">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-214" />
                    <span className="text-zinc-700" data-id="element-215">
                      Extracción de puntos negros (comedones).
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-216">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-217" />
                    <span className="text-zinc-700" data-id="element-218">Espátula ultrasónica.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-219">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-220" />
                    <span className="text-zinc-700" data-id="element-221">
                      <strong data-id="element-222">Foto rejuvenecimiento:</strong> cierra poros e
                      ilumina tu piel.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-223">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-224" />
                    <span className="text-zinc-700" data-id="element-225">
                      Tratamiento descongestivo para rosácea y pieles con Acné.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-226">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-227" />
                    <span className="text-zinc-700" data-id="element-228">
                      Tratamiento con luz pulsada para manchas y rosácea.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-229">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-230" />
                    <span className="text-zinc-700" data-id="element-231">
                      Punta de diamante/peeling mecánico. Peeling químico.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-232">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-233" />
                    <span className="text-zinc-700" data-id="element-234">
                      <strong data-id="element-235">Vapor de ozono:</strong> purifica tu piel.
                      Bactericida. Cierra poros.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-236">
                    <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-237" />
                    <span className="text-zinc-700" data-id="element-238">
                      Cabina led & Derma pen.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Corporales & Otros */}
              <div className="flex flex-col gap-8" data-id="element-239">
                <div className="bg-white p-8 rounded-3xl shadow-sm border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-240">
                  <h4 className="text-xl font-bold text-zinc-900 mb-6 flex items-center gap-2 border-b border-zinc-100 pb-4" data-id="element-241">
                    <Heart size={20} className="text-[#C5A059]" data-id="element-242" /> Tratamientos
                    Corporales
                  </h4>
                  <ul className="space-y-4" data-id="element-243">
                    <li className="flex items-start gap-3" data-id="element-244">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-245" />
                      <span className="text-zinc-700" data-id="element-246">
                        <strong data-id="element-247">Body up / Electrodos:</strong> para tonificar
                        glúteos.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-248">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-249" />
                      <span className="text-zinc-700" data-id="element-250">
                        Suavela & Ultracavitación.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-251">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-252" />
                      <span className="text-zinc-700" data-id="element-253">
                        <strong data-id="element-254">Radiofrecuencia:</strong> reducción de celulitis
                        y flacidez.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-255">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-256" />
                      <span className="text-zinc-700" data-id="element-257">
                        Exfoliación corporal.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-258">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-259" />
                      <span className="text-zinc-700" data-id="element-260">Masajes reductores.</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white p-8 rounded-3xl shadow-sm border border-zinc-100 hover:border-[#C5A059]/30 transition-colors" data-id="element-261">
                  <h4 className="text-xl font-bold text-zinc-900 mb-6 flex items-center gap-2 border-b border-zinc-100 pb-4" data-id="element-262">
                    <Sparkles size={20} className="text-[#C5A059]" data-id="element-263" /> Más
                    Servicios
                  </h4>
                  <ul className="space-y-4" data-id="element-264">
                    <li className="flex items-start gap-3" data-id="element-265">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-266" />
                      <span className="text-zinc-700" data-id="element-267">
                        <strong data-id="element-268">Depilación Definitiva:</strong> Olvidate para
                        siempre de la cera y los vellos no deseados.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-269">
                      <CheckCircle2 size={18} className="text-[#C5A059] shrink-0 mt-0.5" data-id="element-270" />
                      <span className="text-zinc-700" data-id="element-271">
                        <strong data-id="element-272">Uñas:</strong> Manos y pies impecables que
                        hablan por vos.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-[#C5A059] text-white rounded-3xl p-8 md:p-12 max-w-4xl mx-auto text-center shadow-xl relative overflow-hidden" data-id="element-273">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-[100px] opacity-20" data-id="element-274"></div>
          <h4 className="text-2xl font-bold mb-4 relative z-10" data-id="element-275">
            "No sé exactamente qué necesito..."
          </h4>
          <p className="text-lg mb-8 relative z-10" data-id="element-276">
            No hay problema. Agendá una consulta gratuita y lo definimos juntas.
          </p>
          <Button variant="dark" href={WHATSAPP_LINK} className="relative z-10" data-id="element-277">
            QUIERO SABER QUÉ SERVICIO ES PARA MÍ
          </Button>
        </div>
      </Section>

      {/* 07. TESTIMONIOS */}
      <Section className="bg-rose-50/50" id="testimonios" data-id="element-278">
        <div className="text-center mb-16" data-id="element-279">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-zinc-900 mb-4" data-id="element-280">
            Lo que dicen las que ya se animaron al cambio
          </h2>
          <div className="w-24 h-1 bg-[#C5A059] mx-auto rounded-full" data-id="element-281"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12" data-id="element-282">
          {[{
          n: 'María G.',
          t: 'Llevaba años queriendo cambiar mi color y siempre me daba miedo. Con Belén fue diferente desde el primer mensaje. Me explicó todo, me asesoró y el resultado fue exactamente lo que soñaba. ¡No puedo parar de mirarme!'
        }, {
          n: 'Laura P.',
          t: 'Vine con el cabello destruido por otra coloración. En dos sesiones lo transformó completamente. Ahora está sano, brillante y por fin se ve natural. La recomiendo con los ojos cerrados.'
        }, {
          n: 'Daniela R.',
          t: 'Hice la depilación definitiva y fue la mejor decisión de mi vida. El proceso fue cómodo, profesional y los resultados son increíbles. Belén te hace sentir en confianza desde el primer momento.'
        }].map((review, i) => <div key={i} className="bg-white p-8 rounded-3xl shadow-sm border border-zinc-100 relative" data-id="element-283">
              <Quote className="absolute top-6 right-6 text-rose-100" size={48} data-id="element-284" />
              <div className="flex text-[#C5A059] mb-6 relative z-10" data-id="element-285">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" data-id="element-286" />)}
              </div>
              <p className="text-zinc-700 mb-8 relative z-10 leading-relaxed" data-id="element-287">
                "{review.t}"
              </p>
              <div className="flex items-center gap-3 border-t border-zinc-100 pt-4" data-id="element-288">
                <div className="w-10 h-10 bg-zinc-100 rounded-full flex items-center justify-center font-bold text-zinc-500" data-id="element-289">
                  {review.n.charAt(0)}
                </div>
                <div data-id="element-290">
                  <p className="font-bold text-zinc-900" data-id="element-291">{review.n}</p>
                  <p className="text-xs text-zinc-500" data-id="element-292">Salta</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-293">
          <a href="#" className="inline-flex items-center gap-2 text-[#C5A059] font-bold hover:text-zinc-900 transition-colors" data-id="element-294">
            <Instagram size={20} data-id="element-295" /> ¿Querés ver más? Seguinos en Instagram
            @belen.carrillo.estudio
          </a>
        </div>
      </Section>

      {/* 08. AGENDÁ TU TURNO */}
      <Section className="bg-white" id="reserva" data-id="element-296">
        <div className="max-w-4xl mx-auto" data-id="element-297">
          <div className="text-center mb-12" data-id="element-298">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-zinc-900 mb-4" data-id="element-299">
              Tu transformación empieza con un mensaje.
            </h2>
            <p className="text-xl text-zinc-600" data-id="element-300">
              Sin vueltas. Sin esperas. Simple y rápido.
            </p>
          </div>

          <div className="bg-zinc-50 rounded-3xl p-8 md:p-12 border border-zinc-100 mb-12" data-id="element-301">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-302">
              ¿Cómo funciona?
            </h3>
            <div className="space-y-6" data-id="element-303">
              {[{
              n: '1',
              t: 'Elegí tu servicio',
              d: 'Del menú de arriba o consultanos',
              time: '1 minuto'
            }, {
              n: '2',
              t: 'Contactanos por WhatsApp',
              d: 'Te respondemos a la brevedad',
              time: 'Inmediato'
            }, {
              n: '3',
              t: 'Confirmamos tu turno',
              d: 'Fecha y hora a tu medida',
              time: '5 minutos'
            }, {
              n: '4',
              t: 'Llegás y te transformás',
              d: 'El resto es magia ✨',
              time: 'Tu sesión'
            }].map((step, i) => <div key={i} className="flex items-center gap-6 bg-white p-4 rounded-2xl shadow-sm border border-zinc-100" data-id="element-304">
                  <div className="w-12 h-12 shrink-0 bg-[#C5A059] text-white rounded-full flex items-center justify-center font-bold text-xl" data-id="element-305">
                    {step.n}
                  </div>
                  <div className="flex-1" data-id="element-306">
                    <h4 className="font-bold text-zinc-900" data-id="element-307">{step.t}</h4>
                    <p className="text-sm text-zinc-500" data-id="element-308">{step.d}</p>
                  </div>
                  <div className="hidden sm:block text-right" data-id="element-309">
                    <span className="inline-flex items-center gap-1 text-xs font-bold text-[#C5A059] bg-rose-50 px-3 py-1 rounded-full" data-id="element-310">
                      <Clock size={12} data-id="element-311" /> {step.time}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-312">
            <Button variant="whatsapp" href={WHATSAPP_LINK} className="w-full md:w-auto text-lg px-12 py-5" data-id="element-313">
              <MessageCircle className="mr-2" size={24} data-id="element-314" /> RESERVAR TURNO POR
              WHATSAPP
            </Button>

            <div className="text-center" data-id="element-315">
              <p className="text-zinc-500 mb-2" data-id="element-316">
                ¿Preferís primero hacer una consulta gratuita?
              </p>
              <a href={WHATSAPP_LINK} className="text-[#C5A059] font-bold hover:underline underline-offset-4" data-id="element-317">
                CONSULTAR AHORA — SIN COMPROMISO
              </a>
            </div>
          </div>
        </div>
      </Section>

      {/* 09 & 10. UBICACIÓN & FAQ */}
      <Section className="bg-zinc-900 text-white" id="faq" data-id="element-318">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16" data-id="element-319">
          {/* Ubicación */}
          <div data-id="element-320">
            <h2 className="text-3xl font-serif font-bold mb-8" data-id="element-321">
              Encontranos en Salta
            </h2>

            <div className="space-y-6 mb-8" data-id="element-322">
              <div className="flex items-start gap-4" data-id="element-323">
                <MapPin className="text-[#C5A059] shrink-0 mt-1" size={24} data-id="element-324" />
                <div data-id="element-325">
                  <h4 className="font-bold text-lg" data-id="element-326">Dirección</h4>
                  <p className="text-zinc-400" data-id="element-327">
                    Cerrillos
                    <br data-id="element-328" />
                    Salta, Argentina
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-329">
                <Clock className="text-[#C5A059] shrink-0 mt-1" size={24} data-id="element-330" />
                <div data-id="element-331">
                  <h4 className="font-bold text-lg" data-id="element-332">Horarios</h4>
                  <p className="text-zinc-400" data-id="element-333">
                    Martes a Viernes: 13:00 a 20:00 hs
                    <br data-id="element-334" />
                    Sábados: 09:00 a 15:00 hs
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-335">
                <Phone className="text-[#C5A059] shrink-0 mt-1" size={24} data-id="element-336" />
                <div data-id="element-337">
                  <h4 className="font-bold text-lg" data-id="element-338">Contacto</h4>
                  <p className="text-zinc-400" data-id="element-339">
                    WhatsApp: 3876-5186044
                    <br data-id="element-340" />
                    Instagram: @belen.carrillo.estudio
                  </p>
                </div>
              </div>
            </div>

            {/* Animated Map Placeholder */}
            <div className="relative w-full h-64 bg-zinc-800 rounded-2xl overflow-hidden border border-zinc-700 flex items-center justify-center" data-id="element-341">
              <div className="absolute inset-0 opacity-20" style={{
              backgroundImage: 'radial-gradient(#C5A059 1px, transparent 1px)',
              backgroundSize: '20px 20px'
            }} data-id="element-342"></div>
              <div className="relative z-10 flex flex-col items-center" data-id="element-343">
                <div className="relative" data-id="element-344">
                  <MapPin size={40} className="text-[#C5A059] relative z-10 drop-shadow-lg" fill="white" data-id="element-345" />
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#C5A059] rounded-full animate-ping opacity-40" data-id="element-346"></div>
                </div>
                <div className="mt-3 bg-white text-zinc-900 px-4 py-1.5 rounded-full shadow-lg text-sm font-bold" data-id="element-347">
                  Cerrillos, Salta
                </div>
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div data-id="element-348">
            <h2 className="text-3xl font-serif font-bold mb-8 flex items-center gap-3" data-id="element-349">
              <HelpCircle className="text-[#C5A059]" size={32} data-id="element-350" /> Preguntas
              Frecuentes
            </h2>
            <div className="space-y-1" data-id="element-351">
              <AccordionItem question="¿Necesito turno previo o puedo ir directamente?" answer="Trabajamos exclusivamente con turno para garantizarte toda la atención que merecés. Reservar es rápido y fácil por WhatsApp." data-id="element-352" />
              <AccordionItem question="¿Cuánto dura una sesión de colorimetría?" answer="Depende del servicio. En la consulta previa te informamos el tiempo exacto para que puedas organizarte." data-id="element-353" />
              <AccordionItem question="¿La depilación definitiva duele?" answer="Es un proceso muy tolerable. Usamos tecnología y técnicas que minimizan la molestia al máximo." data-id="element-354" />
              <AccordionItem question="¿Qué pasa si no sé qué servicio necesito?" answer="¡Para eso estamos! Agendá una consulta gratuita y te asesoramos sin ningún compromiso." data-id="element-355" />
              <AccordionItem question="¿Trabajan con todo tipo de cabello?" answer="Sí. Tenemos experiencia con todos los tipos y texturas de cabello, incluyendo cabellos muy dañados o difíciles." data-id="element-356" />
              <AccordionItem question="¿Cómo puedo ver más trabajos realizados?" answer="Seguinos en Instagram @belen.carrillo.estudio donde subimos trabajos constantemente." data-id="element-357" />
            </div>
          </div>
        </div>
      </Section>

      {/* 11. CTA FINAL */}
      <Section className="bg-[#C5A059] text-white text-center py-24 relative overflow-hidden" data-id="element-358">
        <div className="absolute inset-0 bg-black/10 mix-blend-multiply" data-id="element-359"></div>
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(circle at 50% 0%, rgba(255,255,255,0.2) 0%, transparent 70%)'
      }} data-id="element-360"></div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-361">
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-362">
            ¿Hasta cuándo vas a esperar para sentirte como siempre quisiste?
          </h2>

          <div className="text-xl text-white/90 mb-12 leading-relaxed space-y-4" data-id="element-363">
            <p data-id="element-364">
              Cada día que pasa sin animarte al cambio es un día más mirándote
              al espejo sin reconocerte del todo.
            </p>
            <p className="font-bold bg-black/20 inline-block px-6 py-2 rounded-full" data-id="element-365">
              El turno que no reservaste hoy... ya lo reservó otra.
            </p>
            <p data-id="element-366">
              Los cupos son limitados porque cada clienta merece atención
              completa.
            </p>
          </div>

          <p className="text-2xl font-serif italic font-bold mb-10" data-id="element-367">
            ✨ Hoy podría ser el día en que todo cambie.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-368">
            <Button variant="dark" href={WHATSAPP_LINK} className="text-lg px-10 py-5 w-full sm:w-auto shadow-2xl" data-id="element-369">
              🌟 QUIERO MI TRANSFORMACIÓN
            </Button>
            <Button href={WHATSAPP_LINK} className="bg-white text-[#C5A059] hover:bg-zinc-50 text-lg px-10 py-5 w-full sm:w-auto shadow-2xl" data-id="element-370">
              💬 PREFIERO CONSULTAR PRIMERO
            </Button>
          </div>
        </div>
      </Section>

      {/* 12. FOOTER */}
      <footer className="bg-[#fbfbfb] pt-16 pb-8" data-id="element-371">
        <div className="max-w-6xl mx-auto px-6" data-id="element-372">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-373">
            {/* LOGO SIZE INCREASED SIGNIFICANTLY */}
            <img src={LOGO_URL} alt="Belén Carrillo Estudio" className="h-36 md:h-48 object-contain mix-blend-multiply" data-id="element-374" />

            <div className="flex gap-4" data-id="element-375">
              <a href="#" className="w-12 h-12 rounded-full bg-white border border-zinc-200 flex items-center justify-center text-zinc-600 hover:bg-[#C5A059] hover:text-white hover:border-[#C5A059] transition-all shadow-sm" data-id="element-376">
                <Instagram size={24} data-id="element-377" />
              </a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-white border border-zinc-200 flex items-center justify-center text-zinc-600 hover:bg-[#C5A059] hover:text-white hover:border-[#C5A059] transition-all shadow-sm" data-id="element-378">
                <MessageCircle size={24} data-id="element-379" />
              </a>
            </div>
          </div>

          <div className="pt-8 border-t border-zinc-200 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-zinc-600 font-medium" data-id="element-380">
            <p data-id="element-381">
              © {new Date().getFullYear()} Belén Carrillo Estudio. Todos los
              derechos reservados.
            </p>
            <div className="flex gap-6" data-id="element-382">
              <button onClick={() => setTermsOpen(true)} className="hover:text-[#C5A059] transition-colors" data-id="element-383">
                Términos y Condiciones
              </button>
              <button onClick={() => setPrivacyOpen(true)} className="hover:text-[#C5A059] transition-colors" data-id="element-384">
                Políticas de Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-385">
        <div className="space-y-4" data-id="element-386">
          <p data-id="element-387">
            Estos son los términos y condiciones de uso del sitio web y los
            servicios ofrecidos por Belén Carrillo Estudio.
          </p>
          <h4 className="font-bold text-zinc-900 mt-4" data-id="element-388">1. Turnos y Reservas</h4>
          <p data-id="element-389">
            Los turnos están sujetos a disponibilidad. Solicitamos puntualidad
            para garantizar la calidad del servicio a todas nuestras clientas.
          </p>
          <h4 className="font-bold text-zinc-900 mt-4" data-id="element-390">
            2. Consultas Gratuitas
          </h4>
          <p data-id="element-391">
            La consulta gratuita no genera obligación de compra y tiene como fin
            asesorar sobre el mejor tratamiento para cada caso.
          </p>
        </div>
      </Modal>

      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-392">
        <div className="space-y-4" data-id="element-393">
          <p data-id="element-394">
            En Belén Carrillo Estudio valoramos y respetamos tu privacidad. Esta
            política describe cómo protegemos tus datos.
          </p>
          <h4 className="font-bold text-zinc-900 mt-4" data-id="element-395">1. Uso de Datos</h4>
          <p data-id="element-396">
            La información proporcionada vía WhatsApp o formularios se utiliza
            exclusivamente para coordinar turnos y enviar información relevante
            sobre tu servicio.
          </p>
          <h4 className="font-bold text-zinc-900 mt-4" data-id="element-397">2. Confidencialidad</h4>
          <p data-id="element-398">
            No compartimos tu información personal con terceros bajo ninguna
            circunstancia.
          </p>
        </div>
      </Modal>
    </div>;
}